export const HttpConfig = {
  DefaultTimeout: 60000
}